import React from 'react'
import {Switch, Route} from 'react-router'

//layouts
import DefaultSidebar1 from './layouts/DefaultSidebar1'
import CollapsedSidebar1 from './layouts/CollapsedSidebar1'
import TopNavigation1 from './layouts/TopNavigation1'

//charts
import Chartist from './charts/chartist'
import Recharts from './charts/recharts'

//demos
import Demo1 from './demos/Demo1'

//dashboards
import Geographic from './dashboards/geographic'
import ECommerce from './dashboards/e-commerce'

//documentation
import Installation from './documentation/installation'
import CodeStructure from './documentation/code-structure'
import Faq from './documentation/faq'
import Changelog from './documentation/changelog'
import Credits from './documentation/credits'

//forms
import DefaultForms from './forms/default-forms'
import InputGroups from './forms/input-groups'
import Validation from './forms/validation'
import Sliders from './forms/sliders'
import ReactDatetime from './forms/react-datetime'
import ReactSelect from './forms/react-select'

//icons
import Flags from './icons/flags'
import FontAwesome from './icons/font-awesome'
import Ionicons from './icons/ionicons'
import MaterialDesignIcons from './icons/material-design-icons'
import SimpleLineIcons from './icons/simple-line-icons'
import WeatherIcons from './icons/weather-icons'

//maps
import GoogleMaps from './maps/google-maps'
import VectorMaps from './maps/vector-maps'

//pages
import Home from './pages/home'
import ContactUs from './pages/contact-us'
import EmptyPage from './pages/empty-page'
import CreateAccount from './pages/create-account'
import ErrorPage from './pages/error-page'
import ResetPassword from './pages/reset-password'
import Subscribe from './pages/subscribe'
import UnderMaintenance from './pages/under-maintenance'
import UnlockAccount from './pages/unlock-account'

//tables
import DefaultTables from './tables/default-tables'
import Reactable from './tables/reactable'

//ui-elements
import Badges from './ui-elements/badges'
import Breadcrumbs from './ui-elements/breadcrumbs'
import Buttons from './ui-elements/buttons'
import Images from './ui-elements/images'
import Lists from './ui-elements/lists'
import Pagination from './ui-elements/pagination'
import ProgressBars from './ui-elements/progress-bars'
import SocialMediaButtons from './ui-elements/social-media-buttons'
import Tabs from './ui-elements/tabs'
import Typography from './ui-elements/typography'
import Tooltips from './ui-elements/tooltips'

//notifications
import Alerts from './ui-elements/alerts'
import Modals from './ui-elements/modals'
import Reapop from './notifications/reapop'

//widgets
import ActivityWidgets from './widgets/activity-widgets'
import AreaChartWidgets from './widgets/area-chart-widgets'
import BarChartWidgets from './widgets/bar-chart-widgets'
import DonutChartWidgets from './widgets/donut-chart-widgets'
import IconWidgets from './widgets/icon-widgets'
import LineChartWidgets from './widgets/line-chart-widgets'
import PieChartWidgets from './widgets/pie-chart-widgets'
import TableWidgets from './widgets/table-widgets'
import TextWidgets from './widgets/text-widgets'
import TimelineWidgets from './widgets/timeline-widgets'
import UserWidgets from './widgets/user-widgets'

// Containers
import Login from './containers/Login';
import People from './containers/People';
import PeopleEdit from './containers/PeopleEdit';
import Roles from './containers/Roles';
import RoleEdit from './containers/RoleEdit';
import RoleAdd from './containers/RoleAdd';
import UserView from './containers/UserView';
import Shops from './containers/Shops';
import Profile from './containers/Profile';
import AddShop from './containers/AddShop';
import EmailTemplates from './containers/EmailTemplates';
import EditEmailTemplate from './containers/EditEmailTemplate';
import Quotes from './containers/Quotes';
import QuotesEdit from './containers/QuotesEdit';
import QuotesUpload from './containers/QuotesUpload';
import QuotesEmail from './containers/QuotesEmail';
import Archive from './containers/Archive';
import ArchiveEdit from './containers/ArchiveEdit';
import Customers from './containers/Customers';
import WorkOrder from './containers/WorkOrder';
import ProjectTask from './containers/ProjectTask';
import EditCustomer from './containers/EditCustomer';
import TaskClock from './containers/TaskClock';
import Calendar from './containers/Calendar';
import JobCards from './containers/JobCards';
import JobCardsEdit from './containers/JobCardsEdit';
import JobCardAdd from './containers/JobCardAdd';
import JobCardsTemplate from './containers/JobCardsTemplate';
import WorkOrderAdd from './containers/WorkOrderAdd';
import PeopleAdd from './containers/PeopleAdd';
import QuoteAdd from './containers/QuoteAdd';
import CustomerAdd from './containers/CustomerAdd';
import Analytics from './containers/Analytics';
import EmailTemplatesAdd from './containers/EmailTemplatesAdd';
import Reports from './containers/Reports';
import EmailTemplatesEdit from './containers/EmailTemplatesEdit';
import EditShop from './containers/EditShop';
import EditPeople from './containers/EditPeople';
import Dashboard from './containers/Dashboard';
import BoardSettings from './containers/BoardSettings';
import AddLane from './containers/AddLane';
import AddStage from './containers/AddStage';
import EditStage from './containers/EditStage';
import EditLane from './containers/EditLane';
import Task from './containers/Task';
import DashboardPreView from './containers/DashboardPreView';
import TaskAttachments from './containers/TaskAttachments';
import TaskComments from './containers/TaskComments';
import TaskLogs from './containers/TaskLogs';
import QuoteLogs from './containers/QuoteLogs';
import QuoteApprove from './containers/QuoteApprove';
import QuotesWO from './containers/QuotesWO';
import QuotePreView from './containers/QuotePreView';
import Vendors from './containers/Vendors';
import VendorAdd from './containers/VendorAdd';
import VendorEdit from './containers/VendorEdit';
import Materials from './containers/Materials';
import MaterialsImport from './containers/MaterialsImport';
import MaterialAdd from './containers/MaterialAdd';
import MaterialEdit from './containers/MaterialEdit';
import WorkOrders from './containers/WorkOrders';
import Employees from './containers/Employees';
import Employee from './containers/Employee';
import EmployeeAttachments from './containers/EmployeeAttachments';
import EmployeeLogs from './containers/EmployeeLogs';
import CheckIn from './containers/CheckIn';
import UserCheckIn from './containers/CheckInMain';
import SelectCustomer from './containers/SelectCustomer';
import ConfirmCheckIn from './containers/ConfirmCheckIn';
import SelectWorkOrder from './containers/SelectWorkOrder';
import SelectActivity from './containers/SelectActivity';
import Timesheet from './containers/Reports/timesheet';
import WorkTime from './containers/Reports/worktime';
import TimesheetSummary from "./containers/Reports/timesheetSummary";
import ProductionCost from "./containers/Reports/productionCost";
import MaterialSummary from "./containers/Reports/materialSummary";

const Routes = () => (
      <Switch>
        <Route exact path="/" component={EmptyPage} />
        <Route path="/pages/employees" component={Employees} />
        <Route path="/pages/employee/attach/:id" component={EmployeeAttachments} />
        <Route path="/pages/employee/add" component={Employee} />
        <Route path="/pages/employee/:id/logs" component={EmployeeLogs} />
        <Route path="/pages/employee/:id" component={Employee} />
        <Route path="/pages/people" component={People} />
        <Route path="/pages/edit-people" component={EditPeople} />
        <Route path="/pages/roles" component={Roles} />
        <Route path="/pages/role-edit/:id" component={RoleEdit} />
        <Route path="/pages/role-add" component={RoleAdd} />
        <Route path="/pages/quote-approved" component={QuoteApprove} />
        <Route path="/pages/dashboard-pre-view/:id" component={DashboardPreView} />
        <Route path="/pages/quote-pre-view/:id" component={QuotePreView} />
        <Route path="/pages/logs/:id" component={TaskLogs} />
        <Route path="/pages/quote-logs/:id" component={QuoteLogs} />
        <Route path="/pages/comments/:id" component={TaskComments} />
        <Route path="/pages/attach/:id" component={TaskAttachments} />
        <Route path="/pages/boardsettings" component={BoardSettings} />
        <Route path="/pages/add-lane" component={AddLane} />
        <Route path="/pages/add-stage" component={AddStage} />
        <Route path="/pages/stage-edit/:id" component={EditStage} />
        <Route path="/pages/lane-edit/:id" component={EditLane} />
        <Route path="/pages/reports" component={Reports} />
        <Route path="/pages/timesheet/(wo)?/:wo?" component={Timesheet} />
        <Route path="/pages/timesheet-summary" component={TimesheetSummary} />
        <Route path="/pages/materials-report" component={MaterialSummary} />
        <Route path="/pages/production-cost" component={ProductionCost} />
        <Route path="/pages/worktime" component={WorkTime} />
        <Route path="/pages/dashboards" component={Dashboard} />
        <Route path="/pages/people-edit/:id" component={PeopleEdit} />
        <Route path="/pages/user-view" component={UserView} />
        <Route path="/pages/task-clock" component={TaskClock} exact/>
        <Route path="/pages/task-clock/:id" component={TaskClock} />
        <Route path="/pages/task/:id" component={Task} />
        <Route path="/pages/analytics" component={Analytics} />
        <Route path="/pages/email-template-add" component={EmailTemplatesAdd} />
        <Route path="/pages/email-template-edit/:id" component={EmailTemplatesEdit} />
        <Route path="/pages/job-cards-add" component={JobCardAdd} />
        <Route path="/pages/quote" component={QuoteAdd} />
        <Route path="/pages/user" component={PeopleAdd} />
        <Route path="/pages/calendar" component={Calendar} />
        <Route path="/pages/job-cards-edit/:id" component={JobCardsEdit} />
        {/*<Route path="/pages/job-cards" component={JobCards} />*/}
        <Route path="/pages/jobcardstemplate" component={JobCardsTemplate} />
        <Route path="/pages/shops" component={Shops} />
        <Route path="/pages/add-shop" component={AddShop} />
        <Route path="/pages/edit-shop/:id" component={EditShop} />
        <Route path="/pages/emailtemplates" component={EmailTemplates} />
        <Route path="/pages/edit-email-template" component={EditEmailTemplate} />
        <Route path="/pages/quotes" component={Quotes} />
        <Route path="/pages/quotes-edit/:id" component={QuotesEdit} />
        <Route path="/pages/quotes-wo/:id" component={QuotesWO} />
        <Route path="/pages/quotes-upload" component={QuotesUpload} />
        <Route path="/pages/quotes-email" component={QuotesEmail} />
        <Route path="/pages/customers" component={Customers} />
        <Route path="/pages/customer" component={CustomerAdd} />
        <Route path="/pages/vendors" component={Vendors} exact />
        <Route path="/pages/vendor" component={VendorAdd} exact />
        <Route path="/pages/vendor/:id" component={VendorEdit} exact />
        <Route path="/pages/materials" component={Materials} exact />
        <Route path="/pages/materials/import" component={MaterialsImport} exact />
        <Route path="/pages/material" component={MaterialAdd} exact />
        <Route path="/pages/material/:id" component={MaterialEdit} exact />
        {/* <Route path="/pages/work-order" component={WorkOrder} /> */}
        <Route path="/pages/work-order" component={WorkOrderAdd} />
        <Route path="/pages/work-orders" component={WorkOrders} />
        <Route path="/pages/project-task/:id" component={ProjectTask} />
        <Route path="/pages/edit-customer/:id" component={EditCustomer} />
        <Route path="/pages/archive" component={Archive} />
        <Route path="/pages/archive-edit" component={ArchiveEdit} />
        <Route path="/dashboards/analytics" component={Analytics} />
        <Route path="/pages/customer" component={CustomerAdd} />
        <Route path="/pages/check-in" component={CheckIn} exact />
        <Route path="/pages/check-in/:userid" component={UserCheckIn} exact />
        <Route path="/pages/check-in/:userid/customers" component={SelectCustomer} exact />
        <Route path="/pages/check-in/:customerID/work-order" component={SelectWorkOrder} exact />
        <Route path="/pages/check-in/:userid/confirm" component={ConfirmCheckIn} exact />
        <Route path="/pages/check-in/:userid/activity" component={SelectActivity} exact />
        <Route path="/containers/archive" component={Archive} />
        <Route path="/charts/chartist" component={Chartist} />
        <Route path="/charts/recharts" component={Recharts} />
        <Route path="/dashboards/geographic" component={Geographic} />
        <Route path="/dashboards/e-commerce" component={ECommerce} />
        <Route path="/demos/demo-1" component={Demo1} />
        <Route path="/documentation/change-log" component={Changelog} />
        <Route path="/documentation/code-structure" component={CodeStructure} />
        <Route path="/documentation/credits" component={Credits} />
        <Route path="/documentation/faq" component={Faq} />
        <Route path="/documentation/installation" component={Installation} />
        <Route path="/forms/default-forms" component={DefaultForms} />
        <Route path="/forms/input-groups" component={InputGroups} />
        <Route path="/forms/react-datetime" component={ReactDatetime} />
        <Route path="/forms/react-select" component={ReactSelect} />
        <Route path="/forms/sliders" component={Sliders} />
        <Route path="/forms/validation" component={Validation} />
        <Route path="/icons/flags" component={Flags} />
        <Route path="/icons/font-awesome" component={FontAwesome} />
        <Route path="/icons/ionicons" component={Ionicons} />
        <Route
          path="/icons/material-design-icons"
          component={MaterialDesignIcons}
        />
        <Route path="/icons/simple-line-icons" component={SimpleLineIcons} />
        <Route path="/icons/weather-icons" component={WeatherIcons} />
        <Route path="/layouts/collapsed-sidebar-1" component={CollapsedSidebar1} />
        <Route path="/layouts/default-sidebar-1" component={DefaultSidebar1} />
        <Route path="/layouts/top-navigation-1" component={TopNavigation1} />
        <Route path="/maps/google-maps" component={GoogleMaps} />
        <Route path="/maps/vector-maps" component={VectorMaps} />
        <Route path="/notifications/reapop" component={Reapop} />
        <Route path="/pages/contact-us" component={ContactUs} />
        <Route path="/pages/create-account" component={CreateAccount} />
        <Route path="/pages/empty-page" component={EmptyPage} />
        <Route path="/pages/error-page" component={ErrorPage} />
        <Route path="/pages/home" component={Home} />
        <Route path="/pages/login" component={Login} />
        <Route path="/pages/profile" component={Profile} />
        <Route path="/pages/reset-password" component={ResetPassword} />
        <Route path="/pages/subscribe" component={Subscribe} />
        <Route path="/pages/under-maintenance" component={UnderMaintenance} />
        <Route path="/pages/unlock-account" component={UnlockAccount} />
        <Route path="/tables/default-tables" component={DefaultTables} />
        <Route path="/tables/reactable" component={Reactable} />
        <Route path="/ui-elements/alerts" component={Alerts} />
        <Route path="/ui-elements/badges" component={Badges} />
        <Route path="/ui-elements/breadcrumbs" component={Breadcrumbs} />
        <Route path="/ui-elements/buttons" component={Buttons} />
        <Route path="/ui-elements/images" component={Images} />
        <Route path="/ui-elements/lists" component={Lists} />
        <Route path="/ui-elements/modals" component={Modals} />
        <Route path="/ui-elements/pagination" component={Pagination} />
        <Route path="/ui-elements/progress-bars" component={ProgressBars} />
        <Route
          path="/ui-elements/social-media-buttons"
          component={SocialMediaButtons}
        />
        <Route path="/ui-elements/tabs" component={Tabs} />
        <Route path="/ui-elements/tooltips" component={Tooltips} />
        <Route path="/ui-elements/typography" component={Typography} />
        <Route path="/widgets/activity-widgets" component={ActivityWidgets} />
        <Route path="/widgets/area-chart-widgets" component={AreaChartWidgets} />
        <Route path="/widgets/bar-chart-widgets" component={BarChartWidgets} />
        <Route path="/widgets/donut-chart-widgets" component={DonutChartWidgets} />
        <Route path="/widgets/icon-widgets" component={IconWidgets} />
        <Route path="/widgets/line-chart-widgets" component={LineChartWidgets} />
        <Route path="/widgets/pie-chart-widgets" component={PieChartWidgets} />
        <Route path="/widgets/table-widgets" component={TableWidgets} />
        <Route path="/widgets/text-widgets" component={TextWidgets} />
        <Route path="/widgets/timeline-widgets" component={TimelineWidgets} />
        <Route path="/widgets/user-widgets" component={UserWidgets} />
        <Route component={EmptyPage} />
      </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js